module.exports = __webpack_public_path__ + "img/capital-country.d5094863.png";